import React, { useEffect, useState } from "react";
import { Icon } from "@blueprintjs/core";
import { useRef } from "react";
import { Button, InputGroup, FormGroup } from "@blueprintjs/core";
import axios from "axios";
import Cookies from "js-cookie";
import { FilledButton } from "../buttons-20250224T111359Z-001/buttons";
import ScrollableDropdown from "../shared/ScrollableDropdown";
import { inject, observer } from "mobx-react";
import ToastStore from "../../stores/ToastStore";
import "./MultiLevelRatingDialog.css";
const MultiLevelReviewSteps = inject("ToastStore")(observer(({ globalReviewSteps = [], onSave, onCancel }) => {

  const stepperRef = useRef(null);
  const [jobProfileOptions, setJobProfileOptions] = useState([]);
  const [steps, setSteps] = useState(() => {
    if (globalReviewSteps && globalReviewSteps.length) {
      return globalReviewSteps.map((step, index) => ({
        id: Date.now() + index,
        name: step[0] || "",
        job_profile_id: step[1] || ""
      }));
    }
    return [{ id: Date.now(), name: "", job_profile_id: "" }];
  });

  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  // Fetch Job Profiles
  useEffect(() => {
    axios.get(`${Cookies.get("apiEnv")}/job_profiles`)
      .then(response => {
        const profiles = response.data.map(profile => ({
          id: profile.id,
          label: profile.name
        }));
        setJobProfileOptions(profiles);
      })
      .catch(error => {
        console.error("Error fetching job profiles", error);
        ToastStore?.showToast("Failed to load job profiles", "danger");
      });
  }, []);

  const handleChange = (index, field, value) => {
    const updated = [...steps];
    updated[index][field] = value;
    setSteps(updated);
  };

  const addStep = () => {
    setSteps([...steps, { id: Date.now(), name: "", job_profile_id: "" }]);
  };

  const deleteStep = (index) => {
    const updated = steps.filter((_, i) => i !== index);
    setSteps(updated);
  };

  // Save → Array of Arrays
  const handleSave = () => {


    const invalidStepIndex = steps.findIndex(
      step => !step.name?.trim() || !step.job_profile_id
    );

    if (invalidStepIndex !== -1) {
      ToastStore?.showToast(
        `Please complete Level ${invalidStepIndex + 1} (name & job profile required)`,
        "warning"
      );
      return;
    }

    const formatted = steps
      .filter(step => step.name && step.job_profile_id)
      .map(step => [step.name, step.job_profile_id]);

    if (formatted.length === 0) {
      ToastStore?.showToast("Please add at least one review level", "warning");
      return;
    }
    onSave && onSave(formatted);
  };

  const handleCancel = () => {

    onCancel && onCancel();
  };

  const updateScrollButtons = () => {
    const el = stepperRef.current;
    if (!el) return;

    const { scrollLeft, clientWidth, scrollWidth } = el;

    setCanScrollLeft(scrollLeft > 0);
    setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 5);
  };

  useEffect(() => {
    const el = stepperRef.current;
    if (!el) return;

    updateScrollButtons();

    el.addEventListener("scroll", updateScrollButtons);
    window.addEventListener("resize", updateScrollButtons);

    return () => {
      el.removeEventListener("scroll", updateScrollButtons);
      window.removeEventListener("resize", updateScrollButtons);
    };
  }, [steps.length]);

  const scrollStepper = (dir) => {
    const el = stepperRef.current;
    if (!el) return;

    el.scrollBy({
      left: dir * 200,
      behavior: "smooth"
    });
  };

  return (
    <div

      style={{
        maxHeight: "70vh",
        overflowY: "auto",
        overflowX: "hidden",
        paddingRight: "8px"
      }}
    >
      <h4>Review Steps</h4>

      {/* Stepper UI */}
      <div style={{ marginBottom: "30px", position: "relative" }}>

        {/* LEFT ARROW */}
        {canScrollLeft && (
          <button
            onClick={() => scrollStepper(-1)}
            style={{
              position: "absolute",
              left: "-10px",
              top: "40%",
              zIndex: 2,
              background: "white",
              border: "1px solid #ddd",
              borderRadius: "50%",
              width: "32px",
              height: "32px",
              cursor: "pointer",
              boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
            }}
          >
            <Icon icon="chevron-left" />
          </button>
        )}

        {/* RIGHT ARROW */}
        {canScrollRight && (
          <button
            onClick={() => scrollStepper(1)}
            style={{
              position: "absolute",
              right: "-10px",
              top: "40%",
              zIndex: 2,
              background: "white",
              border: "1px solid #ddd",
              borderRadius: "50%",
              width: "32px",
              height: "32px",
              cursor: "pointer",
              boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
            }}
          >
            <Icon icon="chevron-right" />
          </button>
        )}

        {/* SCROLL AREA */}
        <div
          ref={stepperRef}
          style={{
            overflowX: "auto",
            scrollbarWidth: "none",   // Firefox
            msOverflowStyle: "none"

            //  overflowX: "hidden",
            //  padding: "10px 30px"
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "baseline",
            }}
          >
            {steps.map((step, index) => (
              <React.Fragment key={step.id}>

                {/* Circle */}
                <div style={{ textAlign: "center" }}>
                  <div
                    className="stepper-circle"
                  >
                    {index + 1}
                  </div>

                  {/* Step Name */}
                  <div className="stepper-circle-text">
                    {step.name || `Level ${index + 1}`}
                  </div>
                </div>

                {/* Arrow Line */}
                {index !== steps.length - 1 && (
                  <div
                    className="stepper-circle-line"
                    style={{
                      //flex: 1,
                      minWidth: "50px",
                      height: "2px",
                      background: "#137CBD",
                      position: "relative",
                      margin: "0 10px",
                      flexShrink: 0
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        right: "-6px",
                        top: "-4px",
                        width: 0,
                        height: 0,
                        borderTop: "6px solid transparent",
                        borderBottom: "6px solid transparent",
                        borderLeft: "10px solid #137CBD"
                      }}
                    />
                  </div>
                )}

              </React.Fragment>
            ))}
          </div>
        </div>
      </div>



      {/* Editable Steps */}
      <div
      //style={{ maxHeight: "35vh"}}
      >
        {steps.map((step, index) => (
          <div
            key={step.id}
            style={{
              display: "flex",
              gap: "10px",
              marginBottom: "12px",
              alignItems: "center"
            }}
          >
            <div style={{ width: "70px" }}>
              <b>Step {index + 1}</b>
            </div>


            <InputGroup
              placeholder="Step Name"
              value={step.name}
              onChange={(e) => handleChange(index, "name", e.target.value)}
              className="bp5-large"
              style={{   border: "1px solid rgb(203 206 212)", boxShadow: "none", height: "38px", width: "100%" }}
            />

            <ScrollableDropdown
              width={220}
              label={
                jobProfileOptions.find(opt => opt.id === step.job_profile_id)?.label ||
                "Select Job Profile"
              }
              items={jobProfileOptions}
              getKey={item => item.id}
              getLabel={item => item.label}
              enableSearch
              onSelect={item => handleChange(index, "job_profile_id", item.id)}
            />

            <Button
              icon="trash"
              minimal
              intent="danger"
              onClick={() => deleteStep(index)}
            />
          </div>
        ))}
      </div>

      <Button icon="add" minimal onClick={addStep}>
        Add Step
      </Button>

      {/* Actions */}
      <div style={{ marginTop: "20px", display: "flex", gap: "10px" }}>
        <FilledButton text="Save" onClick={handleSave} />
        <span
          onClick={handleCancel}
          style={{ cursor: "pointer", color: "#1870d5", marginTop: "8px" }}
        >
          Cancel
        </span>
      </div>
    </div>
  );
}));

export default MultiLevelReviewSteps;


